const Menu = [
  {
    label: "Home",
    pathname: "/home"
  },
  {
    label: "Perfil",
    pathname: "/meu-perfil",
  },
  {
    label: "Meus Trabalhos",
    pathname: "/meus-trabalhos",
  },
  {
    label: "Apresentações",
    pathname: "/chatrooms",
  },
  {
    label: "Logout",
    pathname: "/logout"
  },
]

export default Menu;